import { LogarithmicScale } from "chart.js";
import CookieFunctions from "./cookieFunctions";
import MongoHandler from "services/mongoHandler";

class TokenFunctions {

    constructor(){
        this.cookieFunctions = new CookieFunctions();
        this.mongoHandler = new MongoHandler();
    }

    // Set a cookie with the given name, value, and expiration time in milliseconds
    async checkAndSaveToken(token) {
        try {
            console.log("Checking");
            
            const validation = await this.mongoHandler.checkTokenAndRefresh(token);

            console.log(validation.token);

            if (validation.token != null) {
                // Save the token as a cookie
                this.cookieFunctions.setCookie("Token", validation.token, 1000 * 60 * 16);
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    async refreshToken(){
        try {
            const token = this.cookieFunctions.getCookie("Token");
            console.log(token);            
            if(token == `{"error":"Cookie with name Token does not exist"}`){
                return false;
            }          
            const validation = await this.mongoHandler.checkTokenAndRefresh(token); 
            if (validation.token != null) {
                // Save the token as a cookie
                this.cookieFunctions.setCookie("Token", validation.token, 1000 * 60 * 16);
                return true;
            } else {
                this.cookieFunctions.deleteCookie("Token");
                return false;
            }
        } catch (error) {
            console.log(error);
            return false;
        }
    }
}

export default TokenFunctions;